import React from 'react';
import { Link } from 'react-router-dom';
import LineDotLong from '../../images/line-dot-long.png'
import { MDBBtn } from "mdbreact";

class AdminPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            invoiceNo: '',
            responseOne: false,
            responseStatusOne: '',
            orderId: '',
            responseTwo: false,
            responseStatusTwo: '',
            eInvoiceNo: '',
            eInvoiceDateFrom: '',
            eInvoiceDateTo: '',
            responseThree: false,
            responseStatusThree: '',
            responseFour: false,
            responseStatusFour: '',
        };
    }

    sendInvoice = async (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        const { invoiceNo } = this.state;
        console.log(invoiceNo);

        if (invoiceNo) {
            fetch('api/GetData/ResendInvoice?orderIdRandom=' + invoiceNo)
                .then(response => response.text())
                .then(data => {
                    console.log(data);
                    this.setState({ responseOne: true, responseStatusOne: data, responseTwo: false, responseStatusTwo: '', responseThree: false, responseStatusThree: '', responseFour: false, responseStatusFour: '' });
                });
        }
    };

    changePaymentStatus = async (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        const { orderId } = this.state;
        console.log(orderId);

        if (orderId) {
            fetch('api/GetData/ChangePaymentStatus?orderIdRandom=' + orderId)
                .then(response => response.text())
                .then(data => {
                    console.log(data);
                    this.setState({ responseOne: false, responseStatusOne: '', responseTwo: true, responseStatusTwo: data, responseThree: false, responseStatusThree: '', responseFour: false, responseStatusFour: '' });
                });
        }
    };

    eInvoiceNoSubmit = async (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        const { eInvoiceNo } = this.state;
        console.log(eInvoiceNo);

        if (eInvoiceNo) {
            fetch('api/GetData/SubmitEInvoice?orderIdRandom=' + eInvoiceNo)
                .then(response => response.text())
                .then(data => {
                    console.log(data);
                    this.setState({ responseOne: false, responseStatusOne: '', responseTwo: false, responseStatusTwo: '', responseThree: true, responseStatusThree: data, responseFour: false, responseStatusFour: '' });
                });
        }
    };

    eInvoiceDateSubmit = async (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        const { eInvoiceDateFrom, eInvoiceDateTo } = this.state;
        console.log(eInvoiceDateFrom);
        console.log(eInvoiceDateTo);

        if (eInvoiceDateFrom && eInvoiceDateFrom) {
            this.setState({ responseOne: false, responseStatusOne: '', responseTwo: false, responseStatusTwo: '', responseThree: false, responseStatusThree: '', responseFour: true, responseStatusFour: "E-Invoice is submitting to the middleware, please wait..." });
            fetch('api/GetData/SubmitEInvoice?dateFrom=' + eInvoiceDateFrom + '&dateTo=' + eInvoiceDateTo)
                .then(response => response.text())
                .then(data => {
                    console.log(data);
                    this.setState({ responseOne: false, responseStatusOne: '', responseTwo: false, responseStatusTwo: '', responseThree: false, responseStatusThree: '', responseFour: true, responseStatusFour: data });
                });
        }
    };

    changeHandler = event => {
        const { name, value } = event.target;
        this.setState({
            [name]: value
        });
    };

    render() {
        const { invoiceNo, orderId, eInvoiceNo, eInvoiceDateFrom, eInvoiceDateTo, responseStatusOne, responseOne, responseStatusTwo, responseTwo, responseStatusThree, responseThree, responseStatusFour, responseFour } = this.state;
        return (
            <div className="container" style={{ width: "100%", minHeight: "50vh" }}>
                <div className="col-sm-12 row" style={{ margin: "50px auto" }}>
                    <div className="col-xs-12">
                        <div className="col-sm-12 margin">
                            <h3>
                                Resend Invoice
                            </h3>
                        </div>
                        <img src={LineDotLong} />
                    </div>
                    <div className="col-sm-12 margin">
                        <br />
                        <div className="col-lg-8 col-md-8 col-sm-12">
                            <form
                                className="needs-validation form-horizontal"
                                onSubmit={this.sendInvoice}
                                noValidate
                            >
                                <div className="form-group row">
                                    <label className="control-label col-sm-4 mb-0 pt-2" htmlFor="invoiceNo">Invoice No / Order ID</label>
                                    <div className="col-sm-8">
                                        <input
                                            name="invoiceNo"
                                            onChange={this.changeHandler}
                                            type="text"
                                            id="invoiceNo"
                                            className="form-control"
                                            value={invoiceNo}
                                            //placeholder="Name"
                                            required
                                        />
                                        <div className="invalid-feedback">Invoice No / Order ID is required!</div>
                                    </div>
                                </div>
                                <MDBBtn color="primary" type="submit">
                                    Send Invoice
                                </MDBBtn>

                                <div className={`mt-3 ${responseOne == true ? 'alert alert-primary' : ''}`} >{responseStatusOne} </div>
                            </form>
                        </div>
                        <br />
                        <br />
                    </div>

                    {/*
                    <div className="col-xs-12">
                        <div className="col-sm-12 margin">
                            <h3>
                                Change payment status pending to success.
                            </h3>
                        </div>
                        <img src={LineDotLong} />
                    </div>
                    <div className="col-sm-12 margin">
                        <br />
                        <div className="col-lg-8 col-md-8 col-sm-12">
                            <form
                                className="needs-validation form-horizontal"
                                onSubmit={this.changePaymentStatus}
                                noValidate
                            >
                                <div className="form-group row">
                                    <label className="control-label col-sm-4 mb-0 pt-2" htmlFor="invoiceNo">Invoice No / Order ID</label>
                                    <div className="col-sm-8">
                                        <input
                                            name="orderId"
                                            onChange={this.changeHandler}
                                            type="text"
                                            id="orderId"
                                            className="form-control"
                                            value={orderId}
                                            //placeholder="Name"
                                            required
                                        />
                                        <div className="invalid-feedback">Invoice No / Order ID is required!</div>
                                    </div>
                                </div>
                                <MDBBtn color="primary" type="submit">
                                    Change Payment Status
                                </MDBBtn>

                                <div className={`mt-3 ${responseTwo == true ? 'alert alert-primary' : ''}`} >{responseStatusTwo} </div>
                            </form>
                        </div>
                        <br />
                        <br />
                    </div>
                    */}

                    <div className="col-xs-12">
                        <div className="col-sm-12 margin">
                            <h3>
                                E-Invoice Manual Submission (Invoice No)
                            </h3>
                        </div>
                        <img src={LineDotLong} />
                    </div>
                    <div className="col-sm-12 margin">
                        <br />
                        <div className="col-lg-8 col-md-8 col-sm-12">
                            <form
                                className="needs-validation form-horizontal"
                                onSubmit={this.eInvoiceNoSubmit}
                                noValidate
                            >
                                <div className="form-group row">
                                    <label className="control-label col-sm-4 mb-0 pt-2" htmlFor="eInvoiceNo">Invoice No / Order ID</label>
                                    <div className="col-sm-8">
                                        <input
                                            name="eInvoiceNo"
                                            onChange={this.changeHandler}
                                            type="text"
                                            id="eInvoiceNo"
                                            className="form-control"
                                            value={eInvoiceNo}
                                            required
                                        />
                                        <div className="invalid-feedback">Invoice No / Order ID is required!</div>
                                    </div>
                                </div>

                                <MDBBtn color="primary" type="submit">
                                    Submit e-Invoice
                                </MDBBtn>

                                <div className={`mt-3 ${responseThree == true ? 'alert alert-primary' : ''}`} >{responseStatusThree} </div>
                            </form>
                        </div>
                        <br />
                        <br />
                    </div>


                    <div className="col-xs-12">
                        <div className="col-sm-12 margin">
                            <h3>
                                E-Invoice Manual Submission (Invoice Date)
                            </h3>
                        </div>
                        <img src={LineDotLong} />
                    </div>
                    <div className="col-sm-12 margin">
                        <br />
                        <div className="col-lg-8 col-md-8 col-sm-12">
                            <form
                                className="needs-validation form-horizontal"
                                onSubmit={this.eInvoiceDateSubmit}
                                noValidate
                            >
                                <div className="form-group row">
                                    <label className="control-label col-sm-4 mb-0 pt-2" htmlFor="eInvoiceDateFrom">Invoice / Order Date (From)</label>
                                    <div className="col-sm-8">
                                        <input
                                            name="eInvoiceDateFrom"
                                            onChange={this.changeHandler}
                                            type="date"
                                            id="eInvoiceDateFrom"
                                            className="form-control"
                                            value={eInvoiceDateFrom}
                                            required
                                        />
                                        <div className="invalid-feedback">Invoice / Order Date (From) is required!</div>
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="control-label col-sm-4 mb-0 pt-2" htmlFor="eInvoiceDateTo">Invoice / Order Date (To)</label>
                                    <div className="col-sm-8">
                                        <input
                                            name="eInvoiceDateTo"
                                            onChange={this.changeHandler}
                                            type="date"
                                            id="eInvoiceDateTo"
                                            className="form-control"
                                            value={eInvoiceDateTo}
                                            required
                                        />
                                        <div className="invalid-feedback">Invoice / Order Date (To) is required!</div>
                                    </div>
                                </div>

                                <MDBBtn color="primary" type="submit">
                                    Submit e-Invoice
                                </MDBBtn>

                                <div className={`mt-3 ${responseFour == true ? 'alert alert-primary' : ''}`} >{responseStatusFour} </div>
                            </form>
                        </div>
                        <br />
                        <br />
                    </div>
                </div>
            </div>
        );
    }
}

export default AdminPage;


// WEBPACK FOOTER //
// ./src/components/Checkout/AdminPage.js